import DataAPI from '../../../Utils/Api';

export default (type, isPushbot,website,netbanking) => {
   
    return new Promise(function (resolve, reject) {
        DataAPI().post('/loginUser',
            {
                type: type,
                isPushbot: isPushbot
            }
        ).then((response) => {
            resolve(response.data.response);
            if(response.data.result) {
                if(window.location.href.includes("/pb/RBLCares/mobanklitepost")){
                    window['channel'] = "mobankpost"; 
                }
                if(window.location.href.includes("/pb/RBLCares/mobanklitepre")){
                    window['channel'] = "mobankpre"; 
                }
                if(window.location.href.includes("/pb/RBLCares/unifiedapppre")){
                    window['channel'] = "unifiedapppre"; 
                }
                if(window.location.href.includes("/pb/RBLCares/unifiedapppost")){
                    window['channel'] = "unifiedapppost"; 
                }
                if(window.location.href.includes("/pb/RBLCares/mycardpost")){
                    window['channel'] = "mycardpost"; 
                }
                if(window.location.href.includes("/pb/RBLCares/mycardpre")){
                    window['channel'] = "mycardpre"; 
                } else {
                    window['channel'] = window['channel'];
                }
            }
            if(website == "true" && netbanking == ""){
                window.location.href="https://rbl.bank.in"
                    // window.location.href="https://rblpt.rbl.bank.in"
            }
        }).catch((error)=>{
            reject(error);
        })
    })
}